import { render, staticRenderFns } from "./VerbWithModal.vue?vue&type=template&id=ae5b9a20&"
import script from "./VerbWithModal.vue?vue&type=script&lang=js&"
export * from "./VerbWithModal.vue?vue&type=script&lang=js&"
import style0 from "./VerbWithModal.vue?vue&type=style&index=0&id=ae5b9a20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports